
var umu_theme = {};
(function(window, document, $, undefined){
   $(document).ready(function(){
    $(document).on( 'scroll',  throttle(setScrollPos, 200));
        
        $('#scroll-top-link').on('click', scrollToTop);
        $("#btn_search").on('click', function(){
          var btn = $(this);
          var selector = "#"+btn.attr("aria-controls")
          var the_form = $(selector);
          var expanded = btn.attr("aria-expanded");
          if(expanded =="false"){
            btn.attr("aria-expanded",true);
            the_form.slideDown();         
          }else{
            btn.attr("aria-expanded",false);
            the_form.slideUp();
          }
        });
      //});
      $('.social-share li').mouseenter( function(){
        var el = $(this);
        var popup = el.find('.umu-tooltip');
        if (popup){
            var leftpos = (el.width() - popup.outerWidth())/2; 
            popup.css({'left':leftpos + 'px','opacity':'1','bottom':'65px'});
        
        }
    }).mouseleave( function(){
         
        var popup = $(this).find('.umu-tooltip');
        if (popup){
            popup.css({'opacity':'0','bottom':'75px'});
    
        }
        
        });


	});

   // });

    umu_theme.shareWindow;
    umu_theme.openSocial = function(el,media){
     var href = $(el).attr("href");
     if ( 'undefined' !== typeof umu_theme.shareWindow ){ 
      umu_theme.shareWindow.location.href=href;
     }else{
      umu_theme.shareWindow = 	window.open(href,'Dela','menubar=1,toolbar=0,resizable=1,scrollbars=yes,height=400,width=600'); 
      umu_theme.shareWindow.onunload = function(){umu_theme.shareWindow = undefined;}
     }
     return false;
    }
      
      

    // Returns a function, that, when invoked, will only be triggered at most once
// during a given window of time. Normally, the throttled function will run
// as much as it can, without ever going more than once per `wait` duration;
// but if you'd like to disable the execution on the leading edge, pass
// `{leading: false}`. To disable execution on the trailing edge, ditto.
function throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : Date.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = Date.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
    //return func;
  };
      function setScrollPos(){
        if ($(window).scrollTop() > 120) {
            $('#scroll-top-link').addClass('pop');
            $('body').addClass('scrolled');
        } else  if ($(window).scrollTop() <45){
            $('#scroll-top-link').removeClass('pop');
            $('body').removeClass('scrolled');
        }
       


      }
      function scrollToTop() {
       // var verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
     //   var  element = $('body');
      //  var offset = element.offset();
       // var offsetTop = offset.top;
        $('html, body').animate({scrollTop: $('body').offset().top}, 400, 'linear'/*,function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                            } else {
                            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                            }
                        } */);
      } 




})(window, document, jQuery);
